/**
 * Owner: Masa Bayu
 * File: batch05-codes.ts
 * Date:Time: 2026-09-20 00:40
 * Description: CERT-GLOBAL Batch 5 codes — Indic CERTIFIED / Supported.
 */
export const QX_GL_CERT_GLOBAL_BATCH_05_ID = 'QX-GL-CERT-GLOBAL-BATCH-05';
export const QX_GL_CERT_GLOBAL_BATCH_05_TYPE = 'indic-family-batch';
export const QX_BATCH_05_MODEL_VERSION = '1.1.0';
export const QX_BATCH_05_PHASE = 'CLOSED';
/** OPEN stamp — Batch 5 work authorization (not Supported). */
export const QX_BATCH_05_OPENED_AT = '2026-09-19T16:20:00.000Z';
/** READY stamp — Indic evidence packs complete. */
export const QX_BATCH_05_READY_AT = '2026-09-19T16:25:00.000Z';
/** Owner Accept stamp — Batch 5 Indic families CERTIFIED + Supported. */
export const QX_BATCH_05_OWNER_ACCEPTED_AT = '2026-09-19T16:40:00.000Z';
export const QX_BATCH_05_FAMILY_IDS = [
    'devanagari',
    'bengali',
    'gurmukhi',
    'gujarati',
    'odia',
    'tamil',
    'telugu',
    'kannada',
    'malayalam',
    'sinhala',
];
export const QX_BATCH_05_EVIDENCE_AREAS = [
    'identity',
    'script',
    'direction',
    'content',
    'qxw',
    'qxp',
    'reader',
    'search',
    'navigation',
    'annotation',
    'accessibility',
    'serialization',
    'regression',
    'provenance',
];
export function isQxBatch05FamilyId(value) {
    return (typeof value === 'string' &&
        QX_BATCH_05_FAMILY_IDS.includes(value));
}
//# sourceMappingURL=batch05-codes.js.map